// @flow
import { useFilters, useUpdateURLSearchParams } from 'hooks/useQuery'
import * as React from 'react'

import Button from './Button'
import Text from './Text'

type Props = {
  page?: number,
  pageSize?: number,
  total: number,
  previousCallback?: () => void,
  nextCallback?: () => void,
}

function PaginationBorder({ children }: { children: React.Node }): React.Node {
  return (
    <div className="bg-white border-r border-b border-l border-gray-200 border-t-0">
      {children}
    </div>
  )
}

function Pagination({
  page,
  pageSize,
  total,
  previousCallback,
  nextCallback,
}: Props): React.Node {
  const { filters } = useFilters()
  const _page: number =
    page || (isNaN(parseInt(filters.page)) ? 1 : parseInt(filters.page))
  const _pageSize: number =
    pageSize ||
    (isNaN(parseInt(filters.pageSize)) ? 25 : parseInt(filters.pageSize))
  const _total = total || 0

  const updateParams = useUpdateURLSearchParams()
  const onPageChange = (page: string) => updateParams(['page', page])

  return (
    <nav className="inline-flex items-center justify-between w-full py-2 px-4 bg-gray-50">
      <Text className="inline-flex items-center justify-between text-sm text-gray-700 font-medium">
        <span>
          Showing <span>{Math.min((_page - 1) * _pageSize + 1, _total)}</span>{' '}
          to <span>{Math.min(_page * _pageSize, _total)}</span> of{' '}
          <span>{_total}</span> results
        </span>
      </Text>

      <div className="flex space-x-2">
        <Button
          className="bg-white"
          disabled={_page === 1}
          onClick={previousCallback || (() => onPageChange(String(_page - 1)))}
        >
          Previous
        </Button>
        <Button
          className="bg-white"
          disabled={_page === Math.ceil(_total / _pageSize)}
          onClick={nextCallback || (() => onPageChange(String(_page + 1)))}
        >
          Next
        </Button>
      </div>
    </nav>
  )
}

Pagination.Border = PaginationBorder

export default Pagination
